import React from "react";
import { menu } from "config/menu";
import ExpandableTabs from "components/ui/ExpandableTabs";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();

  const handleNavigate = (url) => {
    navigate(url);
  }

  return (
    <div className="w-full max-w-lg px-8 flex items-center">
      <div className="w-full">
        <ExpandableTabs
          tabs={menu}
          onChange={handleNavigate}
        />
      </div>
    </div>
  );
}

export default Footer;